import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/aadityasahay/Documents/code/fabric-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { CarouselProvider, Slide, Slider } from 'fabric-carousel';
import { Playground, Props } from 'docz';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "usage-instructions"
    }}>{`Usage Instructions.`}</h1>

    <p>{`You will need to import the Carousel Provider and give it a configuration in value`}</p>
    <h2 {...{
      "id": "carouselprovider"
    }}>{`CarouselProvider`}</h2>
    <p>{`This is the provider component that take certain values and passes it along the component tree.`}</p>
    <p>{`These are the default values.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`{
    width: "100%",
    height: "100%",
    visibleCount: 1,
    visibleIndex: 1,
    totalSlides: 4,
    infinite: true,
    slideshow: false,
    slideshowDuration: 1000,
    transitionDuration: "0.4s"
}
`}</code></pre>
    <p>{`height and width determine the sizing of the page, visibleCount is the number of slides that are visible.
visibleIndex defines on which slide the page will open up.
totalSlides should be equal to the number of individual slides that have been provided.`}</p>
    <h2 {...{
      "id": "slider"
    }}>{`Slider`}</h2>
    <p>{`Slider is the main wrapper component which inherits properties from the CarouselProvider and uses them to render the slides.`}</p>
    <Props of={Slider} mdxType="Props" />
    <h2 {...{
      "id": "slide"
    }}>{`Slide`}</h2>
    <p>{`Slides are the units of sliders. They require the index prop which should always be in ascending order as you go down the slide tree.`}</p>
    <Props of={Slide} mdxType="Props" />
    <h2 {...{
      "id": "buttons"
    }}>{`Buttons`}</h2>
    <p>{`As of now there are two buttons available for usage, RightButton and LeftButton which can be disabled by`}<inlineCode parentName="p">{`passing withButtons={false}`}</inlineCode>{` to Slider.
However they can be styled and the content within them change in the following way.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{` <Slider buttonStyling= {\`
            border: none;
            background: transparent;
            box-shadow: 0 0 3px #121212;
            border-radius: 50%;
            transition: all 0.2s;
            outline:none;
            font-size: 22px;
            color: #121212;
            &:hover {
                box-shadow: 0 0 10px;
                transform: scale(1.1);
            }
        \`}
        leftButtonText={<strong>{"<"}</strong>}
        rightButtonText={<strong>{">"}</strong>}
>
</Slider>
`}</code></pre>
    <h2 {...{
      "id": "default-usage"
    }}>{`Default Usage`}</h2>
    <Playground __position={2} __code={'<div style={{ height: \'300px\', width: \'100%\' }}>\n  <CarouselProvider\n    value={{\n      width: \'100%\',\n      height: \'100%\',\n      visibleCount: 1,\n      visibleIndex: 1,\n      totalSlides: 4,\n      infinite: true,\n      slideshow: false,\n      slideshowDuration: 1000,\n      transitionDuration: \'0.4s\',\n    }}\n  >\n    <Slider>\n      <Slide index={1}>\n        <h1>hi</h1>\n      </Slide>\n      <Slide index={2}>\n        <h1>hi2</h1>\n      </Slide>\n      <Slide index={3}>\n        <h1>hi3</h1>\n      </Slide>\n      <Slide index={4}>\n        <h1>hi4</h1>\n      </Slide>\n    </Slider>\n  </CarouselProvider>\n</div>'} __scope={{
      props,
      DefaultLayout,
      CarouselProvider,
      Slide,
      Slider,
      Playground,
      Props
    }} mdxType="Playground">
      <div style={{
        height: "300px",
        width: "100%"
      }}>
        <CarouselProvider value={{
          width: "100%",
          height: "100%",
          visibleCount: 1,
          visibleIndex: 1,
          totalSlides: 4,
          infinite: true,
          slideshow: false,
          slideshowDuration: 1000,
          transitionDuration: "0.4s"
        }} mdxType="CarouselProvider"> 
    <Slider mdxType="Slider">
        <Slide index={1} mdxType="Slide">
            <h1>
                hi
            </h1>
        </Slide>
        <Slide index={2} mdxType="Slide">
            <h1>
                hi2
            </h1>
        </Slide>
        <Slide index={3} mdxType="Slide">
            <h1>
                hi3
            </h1>
        </Slide>
        <Slide index={4} mdxType="Slide">
           <h1>
                hi4
            </h1>
        </Slide>
    </Slider>
    </CarouselProvider>
      </div>
    </Playground>
    <h2 {...{
      "id": "slideshow-mode"
    }}>{`Slideshow mode`}</h2>
    <p>{`Slideshow requires you to also set infinite as true.
Slideshow duration dictates how fast the slides change.`}</p>
    <Playground __position={3} __code={'<div style={{ height: \'300px\', width: \'100%\' }}>\n  <CarouselProvider\n    value={{\n      width: \'100%\',\n      height: \'100%\',\n      visibleCount: 1,\n      visibleIndex: 1,\n      totalSlides: 2,\n      infinite: true,\n      slideshow: true,\n      slideshowDuration: 1000,\n      transitionDuration: \'0.4s\',\n    }}\n  >\n    <Slider>\n      <Slide index={1}>\n        <h1>hi</h1>\n      </Slide>\n      <Slide index={2}>\n        <h1>hi2</h1>\n      </Slide>\n    </Slider>\n  </CarouselProvider>\n</div>'} __scope={{
      props,
      DefaultLayout,
      CarouselProvider,
      Slide,
      Slider,
      Playground,
      Props
    }} mdxType="Playground">
      <div style={{
        height: "300px",
        width: "100%"
      }}>
        <CarouselProvider value={{
          width: "100%",
          height: "100%",
          visibleCount: 1,
          visibleIndex: 1,
          totalSlides: 2,
          infinite: true,
          slideshow: true,
          slideshowDuration: 1000,
          transitionDuration: "0.4s"
        }} mdxType="CarouselProvider"> 
    <Slider mdxType="Slider">
        <Slide index={1} mdxType="Slide">
            <h1>
                hi
            </h1>
        </Slide>
        <Slide index={2} mdxType="Slide">
            <h1>
                hi2
            </h1>
        </Slide>
    </Slider>
    </CarouselProvider>
      </div>
    </Playground>
    <h2 {...{
      "id": "visible-count"
    }}>{`Visible Count`}</h2>
    <p>{`If you want to alter the number of slides that are visible on page, modify the visibleCount Property.
If any slides are left over after distribution, they occupy available amount of space equally.`}</p>
    <Playground __position={4} __code={'<div style={{ height: \'300px\', width: \'100%\' }}>\n  <CarouselProvider\n    value={{\n      width: \'100%\',\n      height: \'100%\',\n      visibleCount: 2,\n      visibleIndex: 1,\n      totalSlides: 3,\n      infinite: true,\n      slideshow: false,\n      slideshowDuration: 1000,\n      transitionDuration: \'0.4s\',\n    }}\n  >\n    <Slider>\n      <Slide index={1}>\n        <h1>hi</h1>\n      </Slide>\n      <Slide index={2}>\n        <h1>hi2</h1>\n      </Slide>\n      <Slide index={3}>\n        <h1>hi3</h1>\n      </Slide>\n    </Slider>\n  </CarouselProvider>\n</div>'} __scope={{
      props,
      DefaultLayout,
      CarouselProvider,
      Slide,
      Slider,
      Playground,
      Props
    }} mdxType="Playground">
      <div style={{
        height: "300px",
        width: "100%"
      }}>
        <CarouselProvider value={{
          width: "100%",
          height: "100%",
          visibleCount: 2,
          visibleIndex: 1,
          totalSlides: 3,
          infinite: true,
          slideshow: false,
          slideshowDuration: 1000,
          transitionDuration: "0.4s"
        }} mdxType="CarouselProvider"> 
    <Slider mdxType="Slider">
        <Slide index={1} mdxType="Slide">
            <h1>
                hi
            </h1>
        </Slide>
        <Slide index={2} mdxType="Slide">
            <h1>
                hi2
            </h1>
        </Slide>
        <Slide index={3} mdxType="Slide">
            <h1>
                hi3
            </h1>
        </Slide>
    </Slider>
    </CarouselProvider>
      </div>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      